


























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IVendor } from '@/api/types-vendor'
import VendorRoleOption from './VendorRoleOption.vue'
import VendorStatusOption from './VendorStatusOption.vue'
import VendorTypeOption from './VendorTypeOption.vue'

@Component({
  name: 'VendorStatus',
  components: {
    VendorRoleOption,
    VendorStatusOption,
    VendorTypeOption
  }
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) value!: IVendor;
  modeEmail = false;
  modeText = false;

  mounted() {
    this.$nextTick(() => {
      console.log(
        `Vendor Status mounted ${this.value.notifyMode} ${this.modeEmail}, ${this.modeText}`
      )
      this.modeEmail = this.checkNotifyMode('Email')
      this.modeText = this.checkNotifyMode('Text')
    })
  }

  isDataLoading() {
    const dataLoaded = this.value.vendorId === 0
    console.log(
        `isDataLoading ${this.value.notifyMode} ${this.value.vendorId}`
    )
    return dataLoaded
  }

  // changeText() { this.updateNotificationMode('Text') }

  // changeEmail() { this.updateNotificationMode('Email') }

  setNotifyMode() {
    this.$nextTick(() => {
      console.log(
        `setNotifyMode ${this.value.notifyMode} ${this.modeEmail}, ${this.modeText}`
      )
      const arrModes: Array<string> = []
      if (this.modeEmail) arrModes.push('Email')
      if (this.modeText) arrModes.push('Text')
      this.value.notifyMode = arrModes.length ? arrModes.join(',') : ''
    })
  }

  checkNotifyMode(mode: string) {
    if (this.value.notifyMode == null) return false
    const arrModes = this.value.notifyMode.split(',')
    return arrModes.includes(mode)
  }

  // private updateNotificationMode(mode: string) {
  //   const arrModes = this.value.notifyMode.split(',')
  //   if (arrModes.includes(mode)) {
  //     arrModes.splice(arrModes.indexOf(mode), 1)
  //   } else {
  //     arrModes.push(mode)
  //   }
  //   this.value.notifyMode = arrModes.length ? arrModes.join(',') : ''
  // }
}
